import React, { useState, useEffect, } from "react";
import { Button, } from "react-bootstrap";

import * as UIHelpers from "./UIHelpers";
import RLDD from "react-list-drag-and-drop/lib/RLDD";

export default function ColumnsFilter(props) {

  const [allColumns, setAllColumns] = useState([]);
  const [checkedColumns, setCheckedColumns] = useState([]);

  const [checkedAll, setCheckedAll] = useState(false);
  const [uncheckedAll, setUncheckedAll] = useState(false);


  useEffect(() => {
    if (props?.columns) {
      let temp = [];
      let temp2 = [];
      props?.columns && props.columns.map((item, index) => {
        if (item.show === true) {
          temp2.push({ id: parseInt(item.id), title: item.text });
          temp.push(item);
        }
      });
      setCheckedColumns(temp2);
      let temp1 = [...temp];
      props?.columns && props.columns.map((item, index) => {
        if (item.show !== true) {
          temp1.push(item);
        }
      });
      setAllColumns(temp1);
    }
  }, [props?.columns]);

  const SaveColumnData = () => {
    props.setShowColumnModal(false);
    let temp = [];
    allColumns.map((item, index) => {
      if (item.show === true) {
        temp.push(item);
      }
    })
    let temp1 = [];
    checkedColumns.map((item, index) => {
      temp.map((item1, index1) => {
        if (item.id === item1.id) {
          temp1.push(item1);
        }
      })
    })
    props.updatedCols(temp1);
    props.updatedFields(temp1);
  };

  const onCheckCol = (item, e) => {
    let checkAllchecked = 0
    let temp = [...allColumns];
    temp.map((item1, index) => {
      if (item1.text === item.text) {
        item1.show = !item.show;
      }
      if(item1.show){
        checkAllchecked++;
      }
    });
    console.log("checkAllchecked",checkAllchecked)
    if (temp.length===checkAllchecked){
      setCheckedAll(true)
    }else{
      setCheckedAll(false)
    }
    let temp2 = [];
    temp.map((item, index) => {
      if (item.show === true) {
        temp2.push({ id: parseInt(item.id), title: item.text });
      }
    });
    setCheckedColumns(temp2);
    setAllColumns(temp);
  };

  useEffect(() => {
    let checkAllchecked = 0
    let temp = [...allColumns];
    temp.map((item1, index) => {
      if(item1.show){
        checkAllchecked++;
      }
    });
    console.log("checkAllchecked",checkAllchecked)
    if (temp.length===checkAllchecked){
      setCheckedAll(true)
    }else{
      setCheckedAll(false)
    }
  }, []);

  const handleRLDDChange = (reorderedItems) => {
    console.log('reorderedItems::', reorderedItems)
    setCheckedColumns(reorderedItems);
  };

  function itemRenderer(item, index) {
    // console.log("title::", item);
    return (
      <div className="item">
        <p className="title">
          <i className="fa fa-grip-vertical" />
          &nbsp;&nbsp;&nbsp;&nbsp;{item.title}
        </p>
      </div>
    );
  }

  const checkedUncheckedAll = (tag) => {
    console.log("tag",tag)
    let temp = [...allColumns];
    temp.forEach(item1 => {
      item1.show = tag;
    });
    let temp2 = [];
    temp.forEach(item => {
      if (item.show === true) {
        temp2.push({ id: parseInt(item.id), title: item.text });
      }
    });
    setCheckedAll(tag)
    setCheckedColumns(temp2);
    setAllColumns(temp);
  }

  

  return (
    <div className="custom_cols w-100">
      {/* <h2>Customize Column</h2> */}
      <div className="row mt-5">
        <div className="col-8">
          <div className="row m-0">
            <div className="col-3 d-flex align-items-center">
              <h4 className="m-0">Available Columns 1</h4>
            </div>
            <div className="col-3">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={checkedAll === true ? "checked" : ""}
                  onChange={() => checkedUncheckedAll(!checkedAll)}
                  name="Check All"
                />
                <span style={{ marginRight: '10px', }}></span>
                {"  "}{'Check All'}
              </label>
            </div>
          </div>

          <div className="all-fields">
            <div className="row m-0">
              {
                allColumns &&
                allColumns.map((item, index) => {
                  return (
                    <div className="col-4">
                      <label className="checkbox" key={index}>
                        <input
                          type="checkbox"
                          checked={item.show === true ? "checked" : ""}
                          onChange={(e) => onCheckCol(item, e)}
                          name={item.text}
                        />
                        <span></span>
                        {"  "}{item.text}
                      </label>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <div className="col-4">
          <h4>Column Arrangement</h4>
          <div className="selected-fields">
            <RLDD
              items={checkedColumns}
              itemRenderer={itemRenderer}
              onChange={handleRLDDChange}
            />
          </div>
        </div>
      </div>

      <div className="column_submit mt-4 text-right">
        <Button
          className="mr-3 btn-secondary"
          onClick={() => props?.setShowColumnModal(false)}
        >
          Cancel
        </Button>
        <Button className="btn-primary" onClick={() => SaveColumnData()}>
          Save
        </Button>
      </div>
    </div>
  )
}